import { render, staticRenderFns } from "./pageFooter.vue?vue&type=template&id=0f576d75&scoped=true&"
var script = {}
import style0 from "./pageFooter.vue?vue&type=style&index=0&id=0f576d75&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f576d75",
  null
  
)

export default component.exports